export enum DictionaryKeysEnum {
    COMPANIES = 'companies',
    STORE_GROUPS = 'store_groups',
    STORES = 'stores',
    STATIONS = 'stations',
}
